import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Height({ item, index }) {

  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">5'8"</div>
    } else {
      return <>
        <div className="col-8">Height</div>
        <div className="col-4">5'8"</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}